import React, { useState, useRef } from 'react';
import type { SelectValue } from "ui-kit/src/MultipleSelect/types";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import '../../style/dieLigen.css';

interface SearchInputProps {
    value: SelectValue | null;
    onChange: (value: SelectValue | null) => void;
    placeholder: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({ value, onChange, placeholder }) => {
    const [inputValue, setInputValue] = useState(value?.value?.toString() || '');
    const inputRef = useRef<HTMLInputElement>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;

        if (newValue === '' || /^\d+$/.test(newValue)) {
            setInputValue(newValue);
            
            if (newValue === '') {
                onChange(null);
            }
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onChange(inputValue ? { value: inputValue, label: inputValue } : null);
            
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    };

    const handleClear = () => {
        setInputValue('');
        onChange(null);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        <div className="select-container">
            <div className="api-react-select">
                <div 
                    className="react-select__control search-input-control"
                    onClick={() => inputRef.current?.focus()}
                >
                    <input
                        ref={inputRef}
                        type="text"
                        value={inputValue}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder={_(placeholder as keyof Keys).toUpperCase()}
                        className="search-input-field"
                    />
                    {inputValue && (
                        <button
                            type="button"
                            onClick={handleClear}
                            className="search-input-clear-button"
                        >
                            ×
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};